// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602050804/js/" + chunkId + "." + {"44":"f0fce406","225":"dcede40d","481":"5d1a1011","486":"7e6ed273","770":"7260d695"}[chunkId] + ".0.7184324599746579.chunk.js";
};